import { useState, useEffect } from 'react'
import { getDistinctValues } from '../../../../util'

export const usePopupDropdownArray = (keyOrdering, popupDropdownArray, insightsElementType) => {
  const [popupDropdownArrayWithAllMonths, setPopupDropdownArrayWithAllMonths] = useState([])

  // Convert string date to proper format
  const convertToDate = (dateString) => {
    const shortMonthArray = {
      jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
      jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11,
    }
    const monthArray = {
      january: 0, february: 1, march: 2, april: 3, may: 4, june: 5,
      july: 6, august: 7, september: 8, october: 9, november: 10, december: 11,
    }
    const phaseArray = { phase1: 2, phase2: 5, phase3: 8, phase4: 11 }
    const periodT = { t1: 3, t2: 7, t3: 11 }
    const periodQ = { q1: 2, q2: 5, q3: 8, q4: 11 }
    const periodH = { h1: 5, h2: 11 }

    const month = dateString.split(' ')?.[0]?.toLowerCase().replaceAll(' ', '')
    const year = dateString.split(' ')?.[1]?.toLowerCase().replace(/\D/g, '')
    
    let monthIndex = 0
    if (shortMonthArray?.[month]) {
      monthIndex = shortMonthArray[month]
    } else if (monthArray?.[month]) {
      monthIndex = monthArray[month]
    } else if (periodT?.[month]) {
      monthIndex = periodT[month]
    } else if (periodQ?.[month]) {
      monthIndex = periodQ[month]
    } else if (phaseArray?.[month]) {
      monthIndex = phaseArray[month]
    } else if (periodH?.[month]) {
      monthIndex = periodH[month]
    }

    const yearNum = parseInt(year) || new Date().getFullYear()
    const date = new Date(yearNum < 50 ? yearNum + 2000 : yearNum, monthIndex, 10)
    const formattedDate = date.toISOString().split('T')[0]
    return formattedDate + 'T10:10:10'
  }

  // Build complete array with all months
  useEffect(() => {
    if (
      keyOrdering?.length > 0 &&
      popupDropdownArray?.length > 0 &&
      popupDropdownArrayWithAllMonths?.length === 0
    ) {
      const popupDropdownArr2 = [...popupDropdownArray]
        .sort((a, b) => {
          return (
            a.drivers.localeCompare(b.drivers) ||
            a.attributes.localeCompare(b.attributes) ||
            a.subAttributes.localeCompare(b.subAttributes) ||
            b.yearMonthVal.localeCompare(a.yearMonthVal)
          )
        })
        .map((d) => ({
          ...d,
          str: `${d.drivers.replaceAll(' ', '_')}_____${d.attributes.replaceAll(' ', '_')}_____${d.subAttributes.replaceAll(' ', '_')}`,
        }))

      const strKeys = getDistinctValues(popupDropdownArr2, 'str').map((s) => s.str)
      const popupDropdownArrayWithAllMnth = []

      for (let i = 0; i < strKeys.length; i++) {
        for (let j = 0; j < keyOrdering.length; j++) {
          const strKey = strKeys[i]
          const strMonth = keyOrdering[j]
          
          let obj =
            popupDropdownArr2
              .filter((f) => f.str === strKey)
              ?.filter((f) => f.label === strMonth)?.[0] || null
              
          if (!obj) {
            const strKeyArray = strKey.split('_____')
            obj = {
              drivers: strKeyArray[0].replaceAll('_', ' '),
              attributes: strKeyArray[1].replaceAll('_', ' '),
              subAttributes: strKeyArray[2].replaceAll('_', ' '),
              str: strKey,
              excel: [],
              label: strMonth,
              fullLabel: strMonth,
              otherDetails: {
                Percent: 0,
                PositivePercent: 0,
                MixedPercent: 0,
                NeutralPercent: 0,
                NegativePercent: 0,
                CreatedDate: convertToDate(strMonth),
              },
              values: { v1: 0, v2: 0, v3: 0, v4: 0 },
              percent: 0,
            }
            
            if (
              [
                'SearchDriversProgression3Level',
                'DriversProgressionWithoutSentiments3Level',
              ].includes(insightsElementType)
            ) {
              obj.values = { v1: 0 }
            }
          }
          
          popupDropdownArrayWithAllMnth.push(obj)
        }
      }
      
      setPopupDropdownArrayWithAllMonths(popupDropdownArrayWithAllMnth)
    }
  }, [keyOrdering, popupDropdownArray, insightsElementType])

  return popupDropdownArrayWithAllMonths
}
